import fetch from '../utils/fetch';

const BaseUrl = process.env.MONO_BASE;
const getUrl = (path) => `${BaseUrl}${path}`;

export default {
  getFonts: () => fetch(getUrl('/assets/fonts')),
};
